import { render } from "./Noti.vue?vue&type=template&id=296bab6c&scoped=true"
import script from "./Noti.vue?vue&type=script&lang=js"
export * from "./Noti.vue?vue&type=script&lang=js"

import "./Noti.vue?vue&type=style&index=0&id=296bab6c&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296bab6c"]])

export default __exports__